import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  templateUrl: './generic-confirmation-dialog.component.html',
  styleUrls: ['./generic-confirmation-dialog.component.scss']
})
export class GenericConfirmationDialogComponent {
  @Input() body: string;
  @Input() title: string;
  @Input() id: number;
  @Input() leftButtonText: string = 'Cancel';
  @Input() rightButtonText: string = 'Delete';
  @Input() leftButtonStyle: string = 'btn btn-primary cancel-button';
  @Input() rightButtonStyle: string = 'btn btn-danger delete-button';

  constructor(protected ref: NbDialogRef<GenericConfirmationDialogComponent>) {
  }

  cancel() {
    this.ref.close(false);
  }

  remove() {
    this.ref.close(true);
  }

}
